import client from '../../client';
import { useMutation } from 'react-query';

const createPurchase = async (data) => {
  // data: { email, firstName, lastName, amount, currency, paymentMethod, paypalOrderId }
  return client.post('/purchase/create', data).then(res => res.data);
};

export const useCreatePurchaseMutation = () => {
  return useMutation({
    mutationFn: createPurchase,
  });
};
